import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { OrchestrationQuery } from '../../state';

@Injectable({ providedIn: 'root' })
export class OrchestrationAclService extends AbstractFeatureAclService<Y42FeatureType.Orchestration> {
  constructor(query: OrchestrationQuery) {
    super({
      featureType: Y42FeatureType.Orchestration,
      query,
    });
  }
}
